<template>
  <!-- <div class="webview flex-row align-items-center"> -->
  <div class="app flex-row align-items-center">
    <div v-if="isLicenseAgreement">
      <web-view-license-agreement-zh/>
    </div>
    <div class="container" v-else>
      <b-row class="justify-content-center">
        <b-col xs="12">
          <div class="clearfix">
            <h1>1on1navi服務使用規約</h1>

            <p>本利用規約（以下「本規約」といいます。）には、株式会社アジャイルＨＲ（以下「当社」といいます。）の提供する本サービス（第2条に定義。）のご利用にあたり、利用者の皆様に遵守していただかなければならない事項及び当社と利用者の皆様との間の権利義務関係が定められております。本サービスをご利用になる方は、本規約に同意する前に、必ず全文お読み下さいますようお願い致します。</p>

            <h2>第1条<span>適　用</span></h2>
            <ul class="list-unstyled">
              <li><span class="nth">1.</span>本規約は、本サービス（第2条に定義）の利用に関する当社と利用者（第2条に定義）との間の権利義務関係を定めることを目的とし、利用者と当社の間の本サービスの利用に関わる一切の関係に適用されます。</li>
              <li><span class="nth">2.</span>当社が本サイト（第2条に定義）上で随時掲載する本サービスに関するルール、諸規定等は本規約の一部を構成するものとします。</li>
            </ul>
            <h2>第2条<span>定　義</span></h2>
            <ul class="list-unstyled">
              <li>本規約において使用する以下の用語は各々以下に定める意味を有するものとします。</li>
              <li>
            <ul class="list-unstyled">
              <li><span class="nth">(1)</span>「本サービス」とは、当社が提供する「1on1navi」という名称のサービス（理由の如何を問わずサービスの名称又は内容が変更された場合は、当該変更後のサービスを含みます。）を意味します。本サービスには、本条で定義する「本サイト」及び「本アプリ」が含まれるものとします。</li>
              <li><span class="nth">(2)</span>「本サイト」とは、そのドメインが「1on1navi.com」である当社が運営するウェブサイト（理由の如何を問わず当社のウェブサイトのドメイン又は内容が変更された場合は、当該変更後のウェブサイトを含みます。）を意味します。</li>
              <li><span class="nth">(3)</span>「本アプリ」とは、本サービスを提供するためのアプリケーションおよび関連ソフトウェアを意味します。</li>
              <li><span class="nth">(4)</span>「契約者」とは、第4条において定義された「契約者」を意味します。</li>
              <li><span class="nth">(5)</span>「登録希望者」とは、第4条において定義された「登録希望者」を意味します。</li>
              <li><span class="nth">(6)</span>「登録情報」とは、第4条において定義された「登録情報」を意味します。</li>
              <li><span class="nth">(7)</span>「利用者」とは、契約者から本サービスの利用を許諾され、第4条に基づき本サービスの利用者としての登録がなされた個人を意味します。</li>
              <li><span class="nth">(8)</span>「ID」とは、本サービスの利用のための利用者毎の固有の文字列（通常は利用者の契約者におけるメールアドレスとします。）を意味します。</li>
              <li><span class="nth">(9)</span>「パスワード」とは、IDに対応して利用者が固有に設定する文字列を意味します。</li>
              <li><span class="nth">(10)</span>「知的財産権」とは、著作権、特許権、実用新案権、商標権、意匠権その他の知的財産権（それらの権利を取得し、又はそれらの権利につき登録等を出願する権利を含みます。）を意味します。</li>
            </ul>
              </li>
            </ul>
            <h2>第3条<span>本サービスの利用</span></h2>
            <ul class="list-unstyled">
              <li>利用者は、第4条第4項に基づき成立する本サービスの利用にかかる契約の有効期間中、本規約に従って、当社の定める方法に従い、本サービスを利用することができます。</li>
            </ul>
            <h2>第4条<span>登　録</span></h2>
            <ul class="list-unstyled">
              <li><span class="nth">1.</span>本サービスは、当社との間で「1on1naviサービス提供契約」を締結した事業者（以下「契約者」といいます。）の役員及び従業員のうち、契約者が利用を承認した者のみが登録できるものとします。本サービスの利用を希望する者（以下「登録希望者」といいます。）は、本規約を遵守することに同意し、かつ当社の定める一定の情報（以下「登録情報」という。）を当社の定める方法で当社に提供することにより、当社に対し、本サービスの利用の登録を申請するものとします。</li>
              <li><span class="nth">2.</span>登録に当たり、利用者は、契約者が許可した情報端末から契約者社内のウェブサイト（SSL証明書を取得するものとします）に開示されたURL経由で本サイトにアクセスする、または同情報端末にGooglePlay等のサービスストアから本アプリをダウンロードし、インストールするものとします。</li>
              <li><span class="nth">3.</span>登録の申請は必ず本サービスを利用する個人が行わなければならず、原則として代理人による登録申請は認めません。また、登録希望者は、登録の申請にあたり、真実、正確かつ最新の情報を当社に提供しなければならないものとします。</li>
              <li><span class="nth">4.</span>本条に基づく登録の完了により、本規約の諸規定に従った本サービスの利用にかかる契約が利用者と当社の間に成立するものとします。</li>
              <li><span class="nth">5.</span>利用者は、利用者の登録情報に変更があった場合は、遅滞なく、当社の定める方法により、当該変更事項を当社に通知し、又は契約者を通じて通知するものとし、当社から要求された資料を提出するものとします。</li>
            </ul>
            <h2>第5条<span>本サービスの利用時間及びサポート体制</span></h2>
            <ul class="list-unstyled">
              <li><span class="nth">1.</span>当社は、本サービスに関し、本規約末尾に掲載する「本サービスの利用時間及びサポート体制等」に記載する利用時間及びサポート体制を提供するよう経済的に合理的な努力を行い本サービスを提供するようものとします。なお、「本サービスの利用時間及びサポート体制等」記載のサービスは、本規約で除外されているサービス及び免責事項に起因して発生した事項については適用されないものとします。</li>
              <li><span class="nth">2.</span>「本サービスの利用時間及びサポート体制等」は本サービスに関する当社の努力目標を定めたものであり、「本サービスの利用時間及びサポート体制等」に記載するサービスが提供できない場合であっても当社は損害賠償責任その他いかなる責任も負わないものとします。</li>
            </ul>
            <h2>第6条<span>アカウント情報の管理</span></h2>
            <ul class="list-unstyled">
              <li><span class="nth">1.</span>利用者は、自己の責任において、本サービスにかかるID及びパスワード（以下「アカウント情報」という。）を管理及び保管するものとし、これを第三者に利用させたり、貸与、譲渡、名義変更、売買等をしてはならないものとします。</li>
              <li><span class="nth">2.</span>当社は、アカウント情報によって本サービスの利用があった場合、利用登録を行った本人が利用したものと扱うことができ、当該利用によって生じた結果並びにそれに伴う一切の責任については、利用者に帰属するものとします。</li>
              <li><span class="nth">3.</span>アカウント情報の管理不十分、使用上の過誤、第三者の使用又はアカウント情報が不正確若しくは虚偽であったこと等による損害の責任は利用者が負うものとし、当社は一切の責任を負わないものとします。</li>
              <li><span class="nth">4.</span>利用者は、利用者のアカウント情報の不正使用によって当社又は第三者に損害が生じた場合、当社および第三者に対して当該損害を賠償するものとします。</li>
              <li><span class="nth">5.</span>利用者は、 アカウント情報が盗まれ、又は第三者に使用されていることが判明した場合には、直ちにその旨を当社に通知するとともに、当社からの指示に従うものとします。</li>
            </ul>
            <h2>第7条<span>禁止行為</span></h2>
            <ul class="list-unstyled">
              <li><span class="nth">1.</span>利用者は、本サービスを利用するにあたり、以下の各号のいずれかに該当する行為をしてはならないものとします。</li>
              <li>
                <ul class="list-unstyled">
                  <li><span class="nth">(1)</span>当社、契約者、又は他の利用者その他の第三者の知的財産権、肖像権、プライバシーの権利、名誉、その他の権利又は利益を侵害する行為（かかる侵害を直接又は間接に惹起する行為を含む。）</li>
                  <li><span class="nth">(2)</span>脅迫行為その他犯罪行為に関連する行為又は公序良俗に反する行為</li>
                  <li><span class="nth">(3)</span>法令又は当社、契約者若しくは利用者が所属する業界団体の内部規則に違反する行為</li>
                  <li><span class="nth">(4)</span>コンピューター・ウィルスその他の有害なコンピューター・プログラムを含む情報を送信する行為</li>
                  <li><span class="nth">(5)</span>本サービスに関し利用しうる情報を改ざんする行為</li>
                  <li><span class="nth">(6)</span>当社が定める一定のデータ容量以上のデータを本サービスを通じて送信する行為その他本サービスのインフラ設備に対して過度な負担となるストレスをかける行為</li>
                  <li><span class="nth">(7)</span>本サイトのサーバーやシステム、セキュリティへの攻撃</li>
                  <li><span class="nth">(8)</span>当社が提供するインターフェース以外の方法で本サービスにアクセスを試みる行為</li>
                  <li><span class="nth">(9)</span>一人の利用者が複数のアカウント情報を取得する行為</li>
                  <li><span class="nth">(10)</span>当社による本サービスの運営を妨害するおそれのある行為</li>
                  <li><span class="nth">(11)</span>その他、当社が不適切と判断する行為</li>
                </ul>
              </li>
              <li><span class="nth">2.</span>当社は、本サービスにおける利用者による情報の送信行為が前項各号のいずれかに該当し、又は該当するおそれがあると当社が判断した場合には、利用者に事前に通知することなく、当該情報の全部又は一部を削除することができるものとします。当社は、本項に基づき当社が行った措置に基づき利用者に生じた損害について一切の責任を負いません。</li>
            </ul>
            <h2>第8条<span>本サービスの停止等</span></h2>
            <ul class="list-unstyled">
              <li><span class="nth">1.</span>当社は、以下のいずれかに該当する場合には、利用者に事前に通知することなく、本サービスの利用の全部又は一部を停止又は中断することができるものとします。</li>
              <li>
                <ul class="list-unstyled">
                  <li><span class="nth">(1)</span>本サービスに係るコンピューター・システムの点検又は保守作業を緊急に行う場合</li>
                  <li><span class="nth">(2)</span>コンピューター、通信回線等が事故により停止した場合</li>
                  <li><span class="nth">(3)</span>火災、停電、天災地変などの不可抗力により本サービスの運営ができなくなった場合</li>
                  <li><span class="nth">(4)</span>その他、当社が停止又は中断を必要と判断した場合</li>
                </ul>
              </li>
              <li><span class="nth">2.</span>当社は、当社の都合により、本サービスの提供を終了することができるものとします。この場合、当社は利用者に事前に通知するものとします。</li>
              <li><span class="nth">3.</span>当社は、本条に基づき当社が行った措置に基づき利用者に生じた損害について一切の責任を負わないものとします。</li>
            </ul>
            <h2>第9条<span>設備の負担等</span></h2>
            <ul class="list-unstyled">
              <li><span class="nth">1.</span>本サービスの提供を受けるために必要な、コンピューター、ソフトウェアその他の機器、通信回線その他の通信環境等の準備及び維持は、利用者の費用と責任において行うものとします。</li>
              <li><span class="nth">2.</span>利用者は自己の本サービスの利用環境に応じて、コンピューター・ウィルスの感染の防止、不正アクセス及び情報漏洩の防止等のセキュリティ対策を自らの費用と責任において講じるものとします。</li>
              <li><span class="nth">3.</span>当社は、利用者が送受信したメッセージその他の情報を運営上一定期間保存していた場合であっても、かかる情報を保存する義務を負うものではなく、当社はいつでもこれらの情報を削除できるものとします。なお、当社はかかる情報の削除に基づき利用者に生じた損害について一切の責任を負わないものとします。</li>
              <li><span class="nth">4.</span>利用者は、本サービスの利用開始に際し又は本サービスの利用中に、ダウンロードその他の方法によりソフトウェア等を利用者のコンピューター等にインストールする場合には、利用者が保有する情報の消滅若しくは改変又は機器の故障、損傷等が生じないよう十分な注意を払うものとし、当社はかかるインストールにより利用者に損害が発生した場合であっても一切責任を負わないものとします。</li>
            </ul>
            <h2>第10条<span>権利帰属</span></h2>
            <ul class="list-unstyled">
              <li><span class="nth">1.</span>本サービスに関する所有権及び知的財産権は全て当社又は当社にライセンスを許諾している者に帰属しており、本規約に定める登録に基づく本サービスの利用許諾は、本規約において明示されているものを除き、本サービスに関する当社又は当社にライセンスを許諾している者の知的財産権の譲渡又は使用許諾を意味するものではありません。利用者は、いかなる理由によっても当社又は当社にライセンスを許諾している者の知的財産権を侵害するおそれのある行為（逆アセンブル、逆コンパイル、リバースエンジニアリングを含むが、これに限定されない。）をしないものとします。</li>
              <li><span class="nth">2.</span>利用者は、当社又は当社にライセンスを許諾している者の知的財産権に係る権利表示及び説明を変更してはならないものとします。</li>
              <li><span class="nth">3.</span>本サービス内において、利用者が投稿その他送信を行った文章についての知的財産権は、当該利用者に帰属するものとします。</li>
            </ul>
            <h2>第11条<span>情報の閲覧</span></h2>
            <ul class="list-unstyled">
              <li><span class="nth">1.</span>当社は、本サービスの利用にかかる契約の違反の有無の確認その他の必要があると当社が判断する場合は、本サービス内において利用者が投稿その他送信を行った文章及びデータ等の内容を閲覧することができるものとします。</li>
              <li><span class="nth">2.</span>当社は、本サービスに関連して統計データを作成するため、本サービス内において利用者が投稿その他送信を行った文章及びデータ等の内容を閲覧することができるものとし、利用者はこれを承認します。</li>
            </ul>
            <h2>第12条<span>登録取消等</span></h2>
            <ul class="list-unstyled">
              <li><span class="nth">1.</span>当社は、利用者が、以下の各号のいずれかの事由に該当する場合は、事前に通知又は催告することなく、当該利用者について本サービスの利用を一時的に停止し、又は利用者としての登録を取り消すことができるものとします。</li>
              <li>
                <ul class="list-unstyled">
                  <li><span class="nth">(1)</span>本規約のいずれかの条項に違反した場合</li>
                  <li><span class="nth">(2)</span>登録情報に虚偽の事実があることが判明した場合</li>
                  <li><span class="nth">(3)</span>当社、他の利用者その他の第三者に損害を生じさせるおそれのある目的又は方法で本サービスを利用した、又は利用しようとした場合</li>
                  <li><span class="nth">(4)</span>手段の如何を問わず、本サービスの運営を妨害した場合</li>
                  <li><span class="nth">(5)</span>当社と契約者との間の本サービスの利用に関する契約が解除その他の事由により終了した場合</li>
                  <li><span class="nth">(6)</span>その他、当社が利用者としての登録の継続を適当でないと判断した場合</li>
                </ul>
              </li>
              <li><span class="nth">2.</span>前項各号のいずれかの事由に該当した場合、利用者は、当社に対して負っている債務の一切について当然に期限の利益を失い、直ちに当社に対して全ての債務の支払を行わなければならないものとします。</li>
              <li><span class="nth">3.</span>当社は、本条に基づき当社が行った行為により契約者及び利用者に生じた損害について一切の責任を負わないものとします。</li>
              <li><span class="nth">4.</span>本条に基づき利用者の登録が取り消された場合、利用者は当社の指示に基づき、当社から提供を受けた本サービスに関連するソフトウェア、その他の物につき、返還、廃棄その他の処分を行うものとします。</li>
            </ul>
            <h2>第13条<span>保証の否認及び免責</span></h2>
            <ul class="list-unstyled">
              <li><span class="nth">1.</span>当社は、本サービスの内容変更、中断、終了によって生じたいかなる損害についても、一切責任を負いません。</li>
              <li><span class="nth">2.</span>当社は、利用者の本サービスの利用環境について一切関与せず、また一切の責任を負いません。</li>
              <li><span class="nth">3.</span>当社は、本サービスが利用者の特定の目的に適合すること、期待する機能・商品的価値・正確性・有用性を有すること、利用者による本サービスの利用が利用者に適用のある法令または業界団体の内部規則等に適合すること、および不具合が生じないことについて、何ら保証するものではありません。</li>
              <li><span class="nth">4.</span>当社は、本サービスが全ての情報端末に対応していることを保証するものではなく、本サービスの利用に供する情報端末のＯＳのバージョンアップ等に伴い、本サービスの動作に不具合が生じる可能性があることにつき、利用者はあらかじめ了承するものとします。当社は、かかる不具合が生じた場合に当社が行うプログラムの修正等により、当該不具合が解消されることを保証するものではありません。</li>
              <li><span class="nth">5.</span>利用者は、GooglePlay等のサービスストアの契約および運用方針の変更等に伴い、本サービスの一部又は全部の利用が制限される可能性があることをあらかじめ了承するものとします。</li>
              <li><span class="nth">6.</span>当社は、本サービスを利用したことにより直接的または間接的に利用者に発生した損害について、一切賠償責任を負いません。</li>
              <li><span class="nth">7.</span>当社は、利用者その他の第三者に発生した機会逸失、業務の中断その他いかなる損害（間接損害や逸失利益を含みます）に対して、当社がかかる損害の可能性を事前に通知されていたとしても、一切の責任を負いません。</li>
              <li><span class="nth">8.</span>第１項から第7項までの規定は、当社に故意または重過失が存する場合には適用しないものとします。</li>
              <li><span class="nth">9.</span>前項が適用される場合であっても、当社は、利用者に生じた損害のうち、特別な事情から生じた損害については、一切賠償する責任を負わないものとします。</li>
              <li><span class="nth">10.</span>本サービスの利用に関し当社が損害賠償責任を負う場合、当社が利用者、契約者及びその他の第三者に対して負担する損害賠償責任の合計額は、当社が契約者から当該損害が発生した月の分として受領する利用料金を限度とするものとします。ただし当社の故意または重過失に起因する場合はその限りではない。</li>
              <li><span class="nth">11.</span>利用者が当社から直接又は間接に、本サービス、本サービスの他の利用者その他の事項に関する何らかの情報を得た場合であっても、当社は利用者に対し本契約において規定されている内容を超えて如何なる保証も行うものではありません。</li>
              <li><span class="nth">12.</span>利用者は、本サービスを利用することが、利用者に適用のある法令、業界団体の内部規則等に違反するか否かを自己の責任と費用に基づいて調査するものとし、当社は、利用者による本サービスの利用が、利用者に適用のある法令、業界団体の内部規則等に適合することを何ら保証するものではありません。</li>
              <li><span class="nth">13.</span>当社は、当社による本サービスの提供の中断、停止、終了、利用不能又は変更、利用者のメッセージ又は情報の削除又は消失､利用者の登録の取消、本サービスの利用によるデータの消失又は機器の故障若しくは損傷、その他本サービスに関連して利用者が被った損害につき、賠償する責任を一切負わないものとします。</li>
              <li><span class="nth">14.</span>本サイトから他のウェブサイトへのリンク又は他のウェブサイトから本サイトへのリンクが提供されている場合でも、当社は、本サイト以外のウェブサイト及びそこから得られる情報に関して如何なる理由に基づいても一切の責任を負わないものとします。</li>
              <li><span class="nth">15.</span>当社は、本サービスにかかる作業の全部又は一部を、第三者に再委託することができるものとし、利用者はあらかじめこれを承諾するものとします。</li>
            </ul>
            <h2>第14条<span>ユーザーの賠償等の責任</span></h2>
            <ul class="list-unstyled">
              <li><span class="nth">1.</span>利用者は、本規約に違反することにより、若しくは本サービスの利用に関連して当社に損害を与えた場合、当社に対し、当社が契約者から当該損害が発生した月の分として受領する利用料金を限度としてその損害を賠償するものとします。ただし契約者の故意または重過失に起因する場合はその限りではありません。</li>
              <li><span class="nth">2.</span>利用者が、本サービスに関連して他の利用者その他の第三者からクレームを受け又はそれらの者との間で紛争を生じた場合には、直ちにその内容を当社に通知するとともに、利用者の費用と責任において当該クレーム又は紛争を処理し、当社からの要請に基づき、その経過及び結果を当社に報告するものとします。また、利用者は、利用者と第三者との間で紛争が生じた場合についても同様にその内容を当社に通知するとともに、利用者の費用と責任において紛争を処理するものとし、当社からの要請に基づき、その経過及び結果を当社に報告するものとします。</li>
              <li><span class="nth">3.</span>利用者は、利用者による本サービスの利用に関連して、当社が、他の利用者その他の第三者から権利侵害その他の理由により何らかの請求を受けた場合は、当該請求に基づき当社が契約者から当該損害が発生した月の分として受領する利用料金を限度として賠償するものとします。ただし契約者の故意または重過失に起因する場合はその限りではありません。</li>
            </ul>
            <h2>第15条<span>秘密保持</span></h2>
            <ul class="list-unstyled">
              <li><span class="nth">1.</span>当社及び利用者は、本サービスの利用にかかる契約の締結および履行に伴い知り得た相手方の業務上または技術上情報であって、相手方が秘密である旨の指定または明示を行った情報（以下「秘密情報」といいます。）を本契約の履行の目的のためのみに使用するとともに、第三者に開示または漏えいしてはならないものとします。ただし、事前に相手方からの書面による同意を得た場合はこの限りではありません。</li>
              <li><span class="nth">2.</span>前項の定めに係らず、以下の各号の情報は、秘密情報に当たらないものとします。</li>
              <li>
                <ul class="list-unstyled">
                  <li><span class="nth">(1)</span>開示の時点で既に公知の情報、または開示後受領者の責によらずして公知となった情報</li>
                  <li><span class="nth">(2)</span>秘密情報を開示した当事者（以下「開示者」という。）が開示を行った時点で既に秘密情報を受領した当事者（以下「受領者」という。）が保有していた情報</li>
                  <li><span class="nth">(3)</span>受領者が第三者から秘密保持義務を負うことなく正当に入手した情報</li>
                  <li><span class="nth">(4)</span>開示者からの開示以降に開発された情報で、開示者からの情報によらないことを証明できる情報</li>
                </ul>
              </li>
              <li><span class="nth">3.</span>国の機関その他から法令に基づき秘密情報の開示を義務付けられた場合、受領者はその開示をすることができるものとします。ただし、受領者はその旨を速やかに開示者に通知するものとします。</li>
              <li><span class="nth">4.</span>当社及び利用者は、本契約終了後または相手方から請求があった場合、相手方の指示に従い、速やかに秘密情報を返却または破棄するものとします。</li>
            </ul>
            <h2>第16条<span>個人情報の保護</span></h2>
            <ul class="list-unstyled">
              <li><span class="nth">1.</span>対象個人情報とは個人情報保護法第2条に定める個人情報を意味します。</li>
              <li><span class="nth">2.</span>当社は、本サービスの運営（以下「本業務」という。）によって知り得た対象個人情報を善良な管理者の注意をもって保管し、書面による承諾を得ることなく本業務の遂行及び統計データの作成以外の目的のために利用し、または第三者に利用させもしくは開示・漏洩しないものとします。</li>
              <li><span class="nth">3.</span>当社は、対象個人情報の漏洩、滅失、毀損の防止その他の対象個人情報の適切な管理のために必要な措置を講じるものとします。</li>
              <li><span class="nth">4.</span>当社は、作成した対象個人情報の複製物を廃棄するときは、書類については裁断または焼却の方法により、電磁的記録についてはデ－タ消去または媒体の破壊の方法により、これを行うものとします。</li>
            </ul>
            <h2>第17条<span>反社会的勢力の排除</span></h2>
            <ul class="list-unstyled">
              <li><span class="nth">1.</span>利用者は、自らが以下の各号のいずれにも該当しないことを表明、保証します。</li>
              <li>
                <ul class="list-unstyled">
                  <li><span class="nth">(1)</span>暴力団、暴力団構成員、準構成員、暴力団関連企業、総会屋、社会運動標ぼうゴロ、政治活動標ぼうゴロ、特殊知能暴力団、その他の反社会的勢力、もしくはそれらに該当しなくなったときから５年を経過しない者（以下「反社会的勢力」という。）</li>
                  <li><span class="nth">(2)</span>東京都暴力団排除条例に規定される規制対象者</li>
                </ul>
              </li>
              <li><span class="nth">2.</span>当社は、利用者が前項各号に定める者に該当することが判明した場合、もしくは利用者に以下各号の一に該当する事由が判明した場合、何らの催告を要せず当該利用者について本サービスの利用を一時的に停止し、又は利用者としての登録を取り消すことができるものとします。</li>
              <li>
                <ul class="list-unstyled">
                  <li><span class="nth">(1)</span>反社会的勢力が経営を支配または実質的に関与していると認められるとき</li>
                  <li><span class="nth">(2)</span>自らまたは第三者の不正の利益を図るもしくは第三者に損害を加える等の目的で反社会的勢力を利用したと認められるとき</li>
                  <li><span class="nth">(3)</span>反社会的勢力に資金等を提供し、または便宜や利益を供するなどの関与をしていると認められるとき</li>
                  <li><span class="nth">(4)</span>自らまたは第三者を利用して暴力的な要求行為、法的責任を超えた不当な要求行為、脅迫的な言動を行い、もしくは暴力を用いる等の行為を行ったとき</li>
                  <li><span class="nth">(5)</span>その他、前各号に準ずるとき</li>
                </ul>
              </li>
              <li><span class="nth">3.</span>当社が前項の規定により本サービスの利用を一時的に停止し、又は利用者としての登録を取り消した場合、その利用者に損害が生じても一切の損害賠償義務を負担しないものとします。</li>
            </ul>
            <h2>第18条<span>有効期間</span></h2>
            <ul class="list-unstyled">
              <li>本サービスの利用にかかる契約は、利用者について第4条に基づく登録が完了した日に効力を生じ、当該利用者の登録が取り消された日又は本サービスの提供が終了した日のいずれか早い日まで、当社と利用者との間で有効に存続するものとします。</li>
            </ul>
            <h2>第19条<span>本契約等の変更</span></h2>
            <ul class="list-unstyled">
              <li><span class="nth">1.</span>当社は、本サービスの内容を自由に変更できるものとします。</li>
              <li><span class="nth">2.</span>当社は、「本サービスの利用時間及びサポート体制等」の内容を、本契約に基づく本サービスの内容を変更しない範囲で自由に変更できるものとします。</li>
              <li><span class="nth">3.</span>当社は、本規約（当社ウェブサイトに掲載する本サービスに関するルール、諸規定等を含みます。以下本項において同じ。）を変更できるものとします。当社は、本規約を変更した場合には、利用者に当該変更内容を通知するものとし、当該変更内容の通知後、利用者が本サービスを利用した場合又は当社の定める期間内に登録取消の手続をとらなかった場合には、利用者は、本規約の変更に同意したものとみなします。</li>
            </ul>
            <h2>第20条<span>連絡/通知</span></h2>
            <ul class="list-unstyled">
              <li>本サービスに関する問い合わせその他利用者から当社に対する連絡又は通知、及び本規約の変更に関する通知その他当社から利用者に対する連絡又は通知は、本サイト内又は本アプリ内の適宜の場所に設置するお問い合わせフォームからの送信、又は当社が別途定める方法で行うものとします。</li>
            </ul>
            <h2>第21条<span>本契約に基づく地位の譲渡等</span></h2>
            <ul class="list-unstyled">
              <li><span class="nth">1.</span>利用者は、当社の書面による事前の承諾なく、本規約上の地位又は本規約に基づく権利若しくは義務につき、第三者に対し、譲渡、移転、担保設定、その他の処分をすることはできないものとします。</li>
              <li><span class="nth">2.</span>当社は本サービスにかかる事業を第三者に譲渡（事業譲渡、会社分割その他態様の如何を問わないものとする。）した場合には、当該譲渡に伴い本契約上の地位、本規約に基づく権利及び義務並びに利用者の登録情報その他の顧客情報を当該譲渡の譲受人に譲渡することができるものとし、利用者は、かかる譲渡につき本項において予め同意したものとします。</li>
            </ul>
            <h2>第22条<span>完全合意</span></h2>
            <ul class="list-unstyled">
              <li>本規約は、本規約に含まれる事項に関する当社と利用者との完全な合意を構成し、口頭又は書面を問わず、本規約に含まれる事項に関する当社と利用者との事前の合意、表明及び了解に優先するものとします。</li>
            </ul>
            <h2>第23条<span>分離可能性</span></h2>
            <ul class="list-unstyled">
              <li>本規約のいずれかの条項又はその一部が、消費者契約法その他の法令等により無効又は執行不能と判断された場合であっても、本規約の残りの規定及び一部が無効又は執行不能と判断された規定の残りの部分は、継続して完全に効力を有し、当社及び利用者は、当該無効若しくは執行不能の条項又は部分を適法とし、執行力を持たせるために必要な範囲で修正し、当該無効若しくは執行不能な条項又は部分の趣旨並びに法律的及び経済的に同等の効果を確保できるように努めるものとします。</li>
            </ul>
            <h2>第24条<span>存続規定</span></h2>
            <ul class="list-unstyled">
              <li>第6条第3項及び第4項、第7条第2項、第8条第3項、第9条、第10条、第11条、第12条第3項、第4項及び第5項、第13条から第17条まで、並びに第21条から第25条までの規定は本契約の終了後も有効に存続するものとする。但し、第15条については、本サービスの利用にかかる契約の終了後3年間に限り存続するものとする。</li>
            </ul>
            <h2>第25条<span>準拠法及び管轄裁判所</span></h2>
            <ul class="list-unstyled">
              <li>本規約の準拠法は日本法とし、本規約に起因し又は関連する一切の紛争については、東京地方裁判所又は東京簡易裁判所を第一審の専属的合意管轄裁判所とします。</li>
            </ul>
            <h2>第26条<span>協議解決</span></h2>
            <ul class="list-unstyled">
              <li>当社及び利用者は、本規約に定めのない事項又は本規約の解釈に疑義が生じた場合には、互いに信義誠実の原則に従って協議の上速やかに解決を図るものとします。</li>
            </ul>
 
            <p class="text-right">【2018年11月30日制定】</p>

            <h3 class="text-center">本サービスの利用時間及びサポート体制等</h3>
            <dl>
            <dt>（利用時間）</dt>
            <dd><ul class="list-unstyled">
            <li>本サービスの利用時間は次の通りとします。ただし、メンテナンス時間を除きます。</li>
            <li>　24時間365日（閏年366日）</li>
            </ul></dd>
            <dt>（サポートデスク受付）</dt>
            <dd><ul class="list-adjusted">
            <li>契約者または利用者からの問合せのみの受付とさせていただきます。</li>
            <li>サポートデスク対応時間</li>
            <li><ul class="list-unstyled">
            <li>①電子メール等による受付：24時間365日（閏年366日）</li>
            <li>②①の対応：平日（※）の10:00-17:00</li>
            <li>（※）平日とは土・日曜日・祝日および年末年始（12月29日から1月3日）を除いた日をいうものとします。</li>
            </ul></li>
            </ul></dd>
            <dt>（メンテナンスのための計画停止等）</dt>
            <dd><ul class="list-adjusted">
            <li>当社は1か月に1回メンテナンスのため6時間計画停止できるものとします。計画停止は、平日の18:00以降の夜間に行うものとします。</li>
            <li>クラウド環境の制限により、メンテナンスのため、定期・不定期（数秒～数分間）にアクセスできない場合があります。</li>
            </ul></dd>
            </dl>

            <p class="text-right">以上</p>

          </div>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<style scoped>
/* .webview {
  overflow: auto;
} */
.app {
  display: block;
  overflow: visible;
  height: 100%;
}
h1 {
  text-align: center;
  font-size: 1.7rem;
  margin: 2rem auto;
}
h2 {
  font-size: 1.25rem;
}
h3 {
  font-size: 1.15rem;
}
h2 > span {
  margin-left: 1em;
  text-decoration: underline;
}
span.nth {
  margin-right: 0.5em;
}
/* ul.list-adjusted {
  padding-left: 1.5em;
} */
ul.list-unstyled {
  margin-bottom: 2rem;
}
ul.list-unstyled li {
  margin: 0.8rem auto;
}
</style>

<script>
import WebViewLicenseAgreementZh from '@/views/_webview/WebViewLicenseAgreementZh'
import { licenseAgreement } from '@/main'

export default {
  name: 'WebViewTermsTrendmicroZH',
  components: {
    WebViewLicenseAgreementZh
  },
  computed: {
    isLicenseAgreement: function () {
      return licenseAgreement
    }
  }

}
</script>



// WEBPACK FOOTER //
// src/views/_webview/WebViewTermsTrendmicroZH.vue